export default __webpack_public_path__ + "static/media/services1.6f37e16e.jpg";